{
  "scheduling": "Penjadwalan Janji Temu",
  "date": "Tanggal",
  "time": "Waktu",
  "duration": "Durasi",
  "provider": "Dokter",
  "reason": "Alasan",
  "status": "Status",
  "statusOptions": {
    "scheduled": "Terjadwal",
    "confirmed": "Dikonfirmasi",
    "arrived": "Sudah Tiba",
    "checked-in": "Sudah Daftar",
    "in-progress": "Dalam Proses",
    "completed": "Selesai",
    "cancelled": "Dibatalkan",
    "no-show": "Tidak Hadir"
  },
  "coverageScope": {
    "panel": "Panel Pasien",
    "unit": "Unit",
    "facility": "Seluruh Fasilitas"
  },
  "coverageScopeDescription": {
    "panel": "Hanya panel pasien dokter yang dicakup.",
    "unit": "Unit yang ditugaskan kepada dokter yang dicakup.",
    "facility": "Seluruh fasilitas — biasanya untuk pengaturan on-call."
  },
  "dayShort": {
    "0": "Min",
    "1": "Sen",
    "2": "Sel",
    "3": "Rab",
    "4": "Kam",
    "5": "Jum",
    "6": "Sab"
  },
  "blockType": {
    "available": "Tersedia",
    "blocked": "Diblokir"
  },
  "appointmentTypes": {
    "followUp": "Kontrol ulang",
    "newPatient": "Pasien baru",
    "consultation": "Konsultasi",
    "procedure": "Prosedur",
    "urgent": "Darurat",
    "wellnessCheck": "Pemeriksaan kesehatan",
    "physical": "Pemeriksaan fisik",
    "telemedicine": "Telemedisin",
    "scheduleTemplate": "Templat jadwal"
  },
  "pages": {
    "providerDirectory": {
      "title": "Direktori Dokter",
      "subtitle": "Telusuri dan cari penyedia layanan kesehatan",
      "search": {
        "namePlaceholder": "Cari berdasarkan nama...",
        "specialtyPlaceholder": "Cari berdasarkan spesialisasi..."
      },
      "filters": {
        "facilityAriaLabel": "Filter berdasarkan fasilitas",
        "departmentAriaLabel": "Filter berdasarkan departemen",
        "allFacilities": "Semua Fasilitas",
        "allDepartments": "Semua Departemen"
      },
      "loading": "Memuat dokter...",
      "loadError": "Gagal memuat direktori dokter.",
      "empty": "Tidak ada dokter yang sesuai dengan kriteria Anda.",
      "npiLabel": "NPI:"
    },
    "scheduleTemplateForm": {
      "title": "Buat Template Jadwal",
      "labels": {
        "provider": "Dokter",
        "dayOfWeek": "Hari",
        "startTime": "Waktu Mulai",
        "endTime": "Waktu Selesai",
        "slotDuration": "Durasi slot (menit)",
        "templateName": "Nama Templat",
        "effectiveStartDate": "Berlaku Mulai"
      },
      "slotDurationOption": "{{minutes}} menit",
      "buttons": {
        "cancel": "Batal",
        "save": "Simpan Template"
      },
      "toast": {
        "success": "Template jadwal tersimpan",
        "failure": "Gagal menyimpan template jadwal"
      },
      "placeholders": {
        "templateName": "mis. Klinik Senin Pagi"
      },
      "defaultName": "Jadwal {{day}}"
    },
    "scheduleManagement": {
      "title": "Manajemen Jadwal",
      "backToDashboard": "← Dasbor",
      "newTemplate": "Template Baru",
      "today": "Hari Ini",
      "blockTooltip": "{{start}} - {{end}} ({{state}})",
      "slotsLabel": "Slot {{minutes}} menit",
      "legend": {
        "booked": "Sudah Dipesan"
      },
      "upcomingAppointmentsHeading": "Janji Temu Mendatang - {{providerName}}",
      "loadingAppointments": "Memuat janji temu...",
      "unknownPatient": "Pasien Tidak Dikenal",
      "fallbackAppointmentType": "Umum",
      "noUpcomingAppointments": "Tidak ada janji temu mendatang untuk dokter ini"
    },
    "providerCoverage": {
      "title": "Cakupan Dokter",
      "subtitle": "Cakupan shift dengan batas waktu — alihkan panel pasien Anda kepada rekan kerja untuk jangka waktu tertentu. Berbeda dari break-glass; digunakan untuk cuti, rotasi on-call, dan ketidakhadiran terencana.",
      "actions": {
        "newCoverage": "Cakupan Baru",
        "cancel": "Batal"
      },
      "form": {
        "title": "Pengaturan cakupan baru",
        "labels": {
          "coveredProviderId": "Dokter yang dicakup",
          "coveringProviderId": "Dokter yang mencakup",
          "scope": "Cakupan",
          "from": "Dari",
          "until": "Sampai",
          "reason": "Alasan"
        },
        "placeholders": {
          "coveredProviderId": "Dokter yang panelnya dicakup",
          "coveringProviderId": "Dokter yang menggantikan selama periode",
          "reason": "mis. Cuti tahunan 22–29 Apr; cakupan on-call akhir pekan"
        },
        "help": {
          "coveredProviderId": "Tanpa COVERAGE_ADMIN, ini harus Anda sendiri.",
          "coveringProviderId": "Cari berdasarkan nama dan pilih — cakupan tidak pernah diberikan ke ID yang diketik."
        },
        "aria": {
          "effectiveFromDate": "Tanggal mulai berlaku",
          "effectiveFromTime": "Jam mulai berlaku",
          "effectiveUntilDate": "Tanggal berakhir berlaku",
          "effectiveUntilTime": "Jam berakhir berlaku"
        },
        "buttons": {
          "cancel": "Batal",
          "create": "Buat cakupan"
        },
        "typeaheadEmpty": "Dokter tidak ditemukan"
      },
      "sections": {
        "mine": {
          "title": "Cakupan Saya",
          "subtitle": "Cakupan di mana saya adalah dokter yang mencakup atau dicakup.",
          "empty": "Tidak ada cakupan tercatat."
        },
        "all": {
          "title": "Semua Cakupan",
          "subtitle": "Setiap pengaturan cakupan di organisasi. Tampilan admin.",
          "empty": "Tidak ada cakupan di mana pun. Itu kabar baik atau filter sudah usang."
        }
      },
      "list": {
        "coveringConnector": "mencakup",
        "groups": {
          "active": "Aktif ({{count}})",
          "planned": "Terencana / Lampau ({{count}})",
          "revoked": "Dicabut ({{count}})"
        },
        "untilRevoked": "sampai dicabut",
        "revokedPrefix": "Dicabut",
        "revokeTitle": "Cabut"
      },
      "revokeDialog": {
        "title": "Cabut cakupan?",
        "description": "{{coveringProviderName}} tidak akan lagi mencakup {{coveredProviderName}}. Catatan tetap ada di jejak audit.",
        "confirm": "Cabut",
        "reasonPlaceholder": "Mengapa cakupan ini diakhiri? (opsional)"
      },
      "toast": {
        "created": "Cakupan dibuat",
        "revoked": "Cakupan dicabut",
        "invalid": "Cakupan tidak valid — periksa dokter dan tanggal",
        "forbidden": "Tidak diizinkan membuat cakupan untuk dokter ini",
        "createFailed": "Gagal membuat cakupan",
        "revokeFailed": "Gagal mencabut cakupan"
      }
    },
    "appointments": {
      "title": "Janji Temu",
      "subtitle": "Jadwalkan dan kelola janji temu pasien",
      "actions": {
        "refresh": "Segarkan",
        "schedule": "Jadwalkan Janji Temu",
        "arriveTitle": "Catat kedatangan",
        "arriveAria": "Catat kedatangan {{patientName}}",
        "checkInTitle": "Daftar masuk",
        "checkInAria": "Daftar masuk {{patientName}}",
        "rescheduleTitle": "Jadwalkan ulang",
        "rescheduleAria": "Jadwalkan ulang {{patientName}}",
        "cancelTitle": "Batal",
        "cancelAria": "Batalkan janji temu {{patientName}}",
        "checkedInLabel": "Sudah daftar",
        "startVisitTitle": "Mulai Kunjungan",
        "startVisitAria": "Mulai kunjungan untuk {{patientName}}"
      },
      "weekNav": {
        "previous": "Minggu sebelumnya",
        "previousAria": "Minggu sebelumnya",
        "next": "Minggu berikutnya",
        "nextAria": "Minggu berikutnya"
      },
      "calendar": {
        "gridAria": "Kalender janji temu mingguan",
        "timeColumn": "Waktu",
        "loading": "Memuat jadwal...",
        "cellAria": "{{dayLabel}} {{date}} pukul {{time}}",
        "cellTitle": "{{patientName}} - {{appointmentType}} ({{status}})"
      },
      "upcoming": {
        "heading": "Janji Temu Mendatang",
        "empty": "Tidak ada janji temu untuk minggu ini",
        "durationMinutes": "{{minutes}} mnt",
        "columns": {
          "dateTime": "Tanggal / Waktu",
          "patient": "Pasien",
          "type": "Jenis",
          "provider": "Dokter",
          "duration": "Durasi",
          "status": "Status",
          "actions": "Tindakan"
        }
      },
      "toast": {
        "cancelled": "Janji temu dibatalkan",
        "cancelFailed": "Gagal membatalkan janji temu",
        "visitStarted": "Kunjungan dimulai",
        "startVisitFailed": "Gagal memulai kunjungan",
        "arrivalRecorded": "Kedatangan dicatat",
        "arrivalFailed": "Gagal mencatat kedatangan"
      }
    },
    "appointmentForm": {
      "title": {
        "create": "Jadwalkan Janji Baru",
        "edit": "Jadwalkan Ulang Janji"
      },
      "labels": {
        "patient": "Pasien",
        "appointmentType": "Jenis Janji Temu",
        "provider": "Dokter",
        "scheduledAt": "Waktu Janji",
        "duration": "Durasi",
        "reason": "Alasan Kunjungan"
      },
      "placeholders": {
        "patientSearch": "Cari pasien berdasarkan nama atau MRN...",
        "provider": "Nama dokter",
        "reason": "Alasan kunjungan secara singkat..."
      },
      "patientTypeahead": {
        "empty": "Pasien tidak ditemukan"
      },
      "aria": {
        "appointmentDate": "Tanggal janji",
        "appointmentTime": "Waktu janji"
      },
      "durationOption": "{{minutes}} mnt",
      "buttons": {
        "cancel": "Batal",
        "schedule": "Jadwalkan Janji",
        "update": "Perbarui Janji"
      },
      "toast": {
        "created": "Janji berhasil dijadwalkan",
        "updated": "Janji diperbarui",
        "createFailed": "Gagal membuat janji",
        "updateFailed": "Gagal memperbarui janji"
      },
      "validation": {
        "patientRequired": "Silakan pilih pasien",
        "appointmentTypeRequired": "Jenis janji temu wajib diisi",
        "scheduledAtRequired": "Tanggal dan waktu wajib diisi",
        "durationInvalid": "Durasi harus antara 1 dan 480 menit",
        "providerRequired": "Silakan pilih dokter"
      },
      "providerTypeahead": {
        "empty": "Dokter tidak ditemukan"
      },
      "loadingEdit": "Memuat janji temu…",
      "loadEditError": "Janji temu ini tidak dapat dimuat.",
      "patientLocked": "Pasien tidak dapat diubah saat menjadwalkan ulang."
    },
    "waitlist": {
      "title": "Daftar Tunggu Janji Temu",
      "backToDashboard": "← Dasbor",
      "entryCount": "{{count}} entri",
      "searchPlaceholder": "Cari nama pasien, MRN, atau catatan...",
      "clearSearchAria": "Hapus pencarian",
      "filters": {
        "allProviders": "Semua Dokter",
        "allTypes": "Semua Jenis",
        "providerAriaLabel": "Filter berdasarkan dokter",
        "typeAriaLabel": "Filter berdasarkan jenis janji temu"
      },
      "columns": {
        "patient": "Pasien",
        "provider": "Dokter",
        "type": "Jenis",
        "priority": "Prioritas",
        "requestedDates": "Tanggal Diminta",
        "dateAdded": "Tanggal Ditambahkan",
        "notes": "Catatan",
        "actions": "Tindakan",
        "reason": "Alasan"
      },
      "priority": {
        "urgent": "Mendesak",
        "routine": "Rutin",
        "flexible": "Fleksibel"
      },
      "actions": {
        "scheduleTitle": "Jadwalkan janji temu",
        "editPriorityTitle": "Edit prioritas",
        "removeTitle": "Hapus dari daftar tunggu"
      },
      "empty": "Tidak ada entri daftar tunggu yang cocok dengan filter Anda",
      "loadFailed": "Daftar tunggu tidak dapat dimuat. Periksa koneksi Anda dan coba lagi.",
      "modal": {
        "title": "Jadwalkan Janji Temu",
        "closeAria": "Tutup",
        "providerLabel": "Dokter:",
        "requestedLabel": "Diminta:",
        "dateTimeLabel": "Tanggal & Waktu Janji Temu *",
        "dateAria": "Tanggal janji temu",
        "timeAria": "Waktu janji temu",
        "requestedWindow": "Jendela yang diminta: {{start}} — {{end}}",
        "cancel": "Batal",
        "submit": "Jadwalkan"
      },
      "toasts": {
        "removed": "Entri dihapus dari daftar tunggu",
        "priorityUpdated": "Prioritas diperbarui",
        "scheduled": "Janji temu dijadwalkan dan dihapus dari daftar tunggu",
        "dateTimeRequired": "Silakan pilih tanggal dan waktu",
        "updateFailed": "Gagal memperbarui daftar tunggu",
        "promoteOrphaned": "Janji temu telah dibuat tetapi entri daftar tunggu tidak dapat diperbarui. Periksa jadwal sebelum mencoba lagi."
      }
    },
    "checkIn": {
      "title": "Daftarkan pasien",
      "subtitle": "Registrasi — asuransi, otorisasi, dan copay. Pasien sudah tiba.",
      "fields": {
        "insuranceId": "Asuransi",
        "copayAmount": "Jumlah copay",
        "copayCollected": "Copay diterima",
        "authorizationNumber": "Nomor otorisasi",
        "authorizationVerified": "Otorisasi terverifikasi"
      },
      "copayHint": "Menandai copay diterima akan mencatat pembayaran ke akun pasien.",
      "submit": "Selesaikan pendaftaran",
      "cancel": "Batal",
      "toast": {
        "success": "Pasien sudah didaftarkan",
        "failed": "Gagal mendaftarkan pasien"
      }
    },
    "providerTypeahead": {
      "loadError": "Direktori dokter tidak tersedia — periksa koneksi Anda dan coba lagi.",
      "retry": "Coba lagi"
    }
  }
}
